import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { TutorialService } from '@core/services';
import { Subscription } from 'rxjs';
import { ConnectionService } from '../services/connection.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit, OnDestroy {
  // SERVICES
  private tutorialService = inject(TutorialService);
  private connectionService = inject(ConnectionService);

  // INPUTS
  @Input()
  public debugMode: boolean;
  @Input()
  public isTabsOpen: boolean = true;
  public subscriptions: Subscription[] = [];

  @Output() toggleTabs: EventEmitter<boolean> = new EventEmitter();

  // STATE
  public isTicketFeeEnabled = signal(false);
  public activeTab: 'filters' | 'cart' = 'filters';
  public isVip: boolean = false;

  ngOnInit(): void {
    this.initComponent();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  private initComponent() {
    const subscription = this.tutorialService.tutorial$.subscribe(
      tutorialConfig => {
        if (tutorialConfig.activeStepCommand === 'activateMobileCartTab') {
          this.activeTab = 'cart';
        }

        if (
          tutorialConfig.activeStepCommand === 'activateMobileFiltersTab' ||
          tutorialConfig.isTutorialEnded
        ) {
          this.activeTab = 'filters';
        }
      }
    );

    const getCurrentClient$ = this.connectionService
      .getCurrentClient()
      .subscribe(response => {
        this.isTicketFeeEnabled.set(!!response.data?.isTicketFeeEnabled);
      });

    this.subscriptions.push(subscription, getCurrentClient$);
  }

  // TEMPLATE VARS
  public templateVars: { title_1: string; title_2: string } = {
    title_1: 'Set your Search Options',
    title_2: 'Price Balance',
  };

  public toggleShowTabs() {
    this.toggleTabs.emit(!this.isTabsOpen);
  }
}
